
export default function SimpleActiveFilterItem({name, handleClick})
{

    return (
        <div className="flex items-center w-full cursor-pointer"
             onClick={handleClick}
        >
            <img
                className="h-5 w-5 pl-0"
                src="/assets/icon/close.svg"
                alt="Search icon"
            />
            <span className="flex-grow mt-0 text-sm text-olaf-green-500">{name}</span>
        </div>
    );
}